import { Box } from "@mui/material";
import AppWrapper from "components/AppWrapper";
import Footer from "components/AppWrapper/Footer";
import FormSteps from "components/FormSteps";
import React from "react";
import logo from "resources/images/logo.png";

export default function Base(): React.ReactElement {
  return (
    <AppWrapper>
      <Box display="flex" alignItems="center" justifyContent="center" py={{ xs: 2, md: 4 }}>
        <img src={logo} alt="logo" className="logo" />
      </Box>
      <FormSteps />
      <Footer />
    </AppWrapper>
  );
}
